import React from "react";
import { Container } from "react-bootstrap";
import "./resume.scss";
import { educations, experience } from "./resumeInfo";
import Education from "./Education";
import Experience from "./Experience";

function Resume() {
  const edu = educations.map((item, indx) => (
    <Education
      key={indx}
      duration={item.duration}
      direction={item.direction}
      description={item.description}
      source={item.source}
    />
  ));
  const exp = experience.map((item, indx) => (
    <Experience
      key={indx}
      duration={item.duration}
      position={item.position}
      description={item.description}
      workPlace={item.workPlace}
    />
  ));

  return (
    <section id="resume" className="resume section">
      <h1>
        My<span>Resume</span>
      </h1>
      <Container className="resume-container">
        <div className="resume-education">
          <h2 className="resume-education-title">Education</h2>
          {edu}
        </div>
        <div className="resume-experience">
          <h2 className="resume-experience-title">Experience</h2>
          {exp}
        </div>
      </Container>
    </section>
  );
}

export default Resume;
